import { render, staticRenderFns } from "./GroupsAdditionalInfo.vue?vue&type=template&id=2cc59aa6&"
import script from "./GroupsAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./GroupsAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports